'use strict';

export default function SearchSwitchTriple({
    type, 
    planesCount, 
    seatsCount, 
    toursCount,
    useLocalStorageCounters = false,
    setSearchScenario = false, 
    onChangeType
}) {

    const handleChangeType = (type) => {
        if (onChangeType)
            onChangeType(type);
        else
            handleChangeTypeDefault(type)
    }

    const handleChangeTypeDefault = (type) => {
        
        let main_link = '/';
        let params = [];
        
        if (setSearchScenario || isSearchScenario()) {
            main_link = '/search';
            params = [{name: 'search', value: 1}];
        }
            
        switch (type) {
            case 'planes':
                openLink(main_link, params)
                break;
            case 'seats':
                !window.Site.isTravel
                    ? openLink('/schedule', params) 
                    : openModal('subscribeByEmailTravel', params)
                break;
            case 'tours':
                
                // todo BEG Временно, пока не сделаем новую страницу отелей
                params = [{name: 'search', value: 1}];
                openLink('/eventscalendar', params)
                // todo END
                
                // openLink('/hotel', params)
                break;
        }
    }
    
    const openLink = (link, params = []) => {
        params = params
            .map(({name, value}) => `${name}=${value}`)
            .join('&')
        params = params ? `?${params}` : ''
        
        window.location.href = (window.lang ? '/' + window.lang : '') + link + params;
    }
    
    const openModal = (name, params = []) => {
        $.fancybox.open({
            src: `#${name}`,
            afterClose: () => {}
        });
    }
    
    const setCountersFromLocalStorage = () => {
        
        if (!useLocalStorageCounters || !isSearchScenario())
            return 
        
        const reactSearchData = storageGetActualSearchData();
        
        planesCount = reactSearchData.planesCount || 0;
        seatsCount = reactSearchData.seatsCount || 0;
        toursCount = reactSearchData.toursCount || 0;
    }
    
    
    setCountersFromLocalStorage();
    

    return <div className="main-tabs__wrapper">
        <div className="main-tabs">
            <a role='button' onClick={() => handleChangeType('planes')} className={clsx({active: type === 'planes'})}>
                <i className="tab-plane"></i>
                {tMsg('Самолеты')}
                {planesCount > 0 && <span data-planes_count>{planesCount}</span>}
            </a>
            <a role='button' onClick={() => handleChangeType('seats')} className={clsx({active: type === 'seats'})}>
                <i className="tab-sofa"></i>
                {tMsg('Места')}
                {seatsCount > 0 && <span data-seats_count>{seatsCount}</span>}
            </a>
            <a role='button' onClick={() => handleChangeType('tours')} className={clsx({active: type === 'tours'})}>
                <i className="tab-marker"></i>
                {tMsg('Отели')}
                {toursCount > 0 && <span data-hotels_count>{toursCount}</span>}
            </a>
        </div>
    </div>
}